module.exports = __webpack_public_path__ + "img/IMG_2254_L.53733b06.webp";